import {App} from "./App";
/**
 * The main entry point of the js application.
 * Bootstrap and run the application.
 */

let app = new App();
// run the application
app.run();





// WEBPACK FOOTER //
// ./assets/ts/src/main.ts